import { environment } from '../../../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular
    .module('app')
    .factory(
      'ClientCommissionProductCategorySettingService',
      ClientCommissionProductCategorySettingService
    );

  ClientCommissionProductCategorySettingService.$inject = [
    'RestResource',
    'UtilService',
    '$translate',
    '$filter',
    'ModalWindowConfirmService',
  ];

  function ClientCommissionProductCategorySettingService(
    RestResource,
    UtilService,
    $translate,
    $filter,
    ModalWindowConfirmService
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'clients';

    var service = {
      saveProductCategorySettings: saveProductCategorySettings,
      deleteProductCategorySettings: deleteProductCategorySettings,
      setProductCategorySettings: setProductCategorySettings,
      groupSettingsByProductCategory: groupSettingsByProductCategory,
      unGroupSettingsByProductCategory: unGroupSettingsByProductCategory,
    };

    return service;

    ////////////////

    function saveProductCategorySettings(
      productCategorySettings,
      clientId,
      clientCommissionSeasonId
    ) {
      var url = apiUrl + '/' + clientId + '/client_commission_seasons/' + clientCommissionSeasonId;
      url += '/client_commission_product_category_settings/update_settings';

      function success(response) {
        utils._successMsg($translate('PRODUCT_CATEGORY_SETTING_UPDATED'));

        return response.data;
      }
      function failure(response) {
        utils._errorMsg(response.data.error);

        return false;
      }

      return RestResource.request(
        'put',
        url,
        { product_category_settings: productCategorySettings },
        success,
        failure
      );
    }

    function deleteProductCategorySettings(
      productCategorySettings,
      clientId,
      clientCommissionSeasonId,
      successCallback
    ) {
      var modalParams = {
        mode: 'danger',
        title: 'SURE_TO_DELETE_PRODUCT_CATEGORY_SETTING',
      };

      var confirmCallback = function () {
        function success() {
          utils._successMsg($translate('SETTING_DELETED'));

          return successCallback();
        }
        function failure(response) {
          utils._errorMsg(response.data.error);

          return false;
        }

        var url =
          apiUrl + '/' + clientId + '/client_commission_seasons/' + clientCommissionSeasonId;
        url += '/client_commission_product_category_settings/delete_settings';

        return RestResource.request(
          'put',
          url,
          { product_category_settings: productCategorySettings },
          success,
          failure
        );
      };

      ModalWindowConfirmService.open(modalParams, confirmCallback);
    }

    function setProductCategorySettings(clientCommissionProductCategorySettings, priceLists) {
      clientCommissionProductCategorySettings = clientCommissionProductCategorySettings || [];

      var settingsByProductCategory = groupSettingsByProductCategory(
        clientCommissionProductCategorySettings
      );

      var productCategorySettings = [];
      settingsByProductCategory.forEach(function (settingByProductCategory) {
        var settingsByPriceList = [];

        priceLists.forEach(function (priceList) {
          var settingId,
            percentage = 0;

          for (var i = 0; i < settingByProductCategory.settingsByPriceList.length; i++) {
            var setting = settingByProductCategory.settingsByPriceList[i];

            if (setting.price_list_id === priceList.id) {
              settingId = setting.id;
              percentage = setting.percentage;
              break;
            }
          }

          var priceListSetting = {
            product_type: settingByProductCategory.product_type,
            percentage: percentage,
            product_category_id: settingByProductCategory.product_category_id,
            price_list_id: priceList.id,
            id: null,
          };

          // Exists
          if (settingId) {
            priceListSetting.id = settingId;
          }

          settingsByPriceList.push(priceListSetting);
        });

        var setting = {
          product_category: settingByProductCategory.product_category,
          product_type: settingByProductCategory.product_type,
          settingsByPriceList: settingsByPriceList,
        };

        productCategorySettings.push(setting);
      });

      return productCategorySettings;
    }

    /* Ex: {
                product_category: { id: value, name: value }, 
                settingsByPriceList: [{ key: value }, { key: value }]
               }
        */
    function groupSettingsByProductCategory(productCategorySettings) {
      var settingsByProductCategory = [];
      var identifier;

      // Group settings by product category
      productCategorySettings.forEach(function (productCategorySetting) {
        identifier = productCategorySetting.product_category_id;

        if (!settingsByProductCategory[identifier]) {
          settingsByProductCategory[identifier] = [];
        }

        settingsByProductCategory[identifier].product_category =
          productCategorySetting.product_category;

        settingsByProductCategory[identifier].product_type = productCategorySetting.product_type;
        settingsByProductCategory[identifier].product_category_id =
          productCategorySetting.product_category_id;
        settingsByProductCategory[identifier].settingsByPriceList =
          settingsByProductCategory[identifier].settingsByPriceList || [];
        settingsByProductCategory[identifier].settingsByPriceList.push({
          id: productCategorySetting.id,
          percentage: productCategorySetting.percentage,
          price_list_id: productCategorySetting.price_list_id,
        });
      });

      return utils.removeKeyFromArrayObject(settingsByProductCategory);
    }

    // In case whe want to save in bulk (embeds_many)
    function unGroupSettingsByProductCategory(productCategorySettings) {
      // console.log('two');
      // console.log(productCategorySettings);
      if (!productCategorySettings) {
        return;
      }

      var settingsByProductCategory = [];

      productCategorySettings.forEach(function (productCategorySetting) {
        productCategorySetting.settingsByPriceList.forEach(function (priceListSetting) {
          settingsByProductCategory.push({
            id: priceListSetting.id,
            product_type: priceListSetting.product_type,
            percentage: priceListSetting.percentage,
            product_category_id: priceListSetting.product_category_id,
            price_list_id: priceListSetting.price_list_id,
          });
        });
      });

      return settingsByProductCategory;
    }
  }
})();
